import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

/**
 * Points MapLibre at the worker file that the build emits.
 *
 * CAUTION: MapLibre resolves its worker from `import.meta.url` and a file name it
 * computes at run time. Vite reads only a literal `new URL(...)`, so it emits no
 * worker asset, and the request falls through to the single-page fallback, which
 * answers with `index.html`. The failure is silent and misleading: raster tiles
 * still draw on the main thread, so a basemap appears while every vector tile is
 * simply never requested.
 *
 * `?worker&url` builds the worker and gives its address. Plain `?url` copies the
 * one file and resolves nothing, so the worker then fails on its own first import.
 */
export const pointMapLibreAtItsWorker = () => setWorkerUrl(workerUrl);
